<template>
  <div
    v-if="isReadyToRenderNavbar"
    class="navbar-container d-flex align-items-center"
  >
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Navbar Menu on top: nav-menu-position use for define position with no effect to other component defined at style.scss-->

    <div class="d-none d-xl-flex nav-menu-position">
      <div
        v-for="(menu, index) in navbarMenu"
        :key="index"
        :class="{
          'text-color-primary font-weight-600': currentModule === menu.module,
        }"
        class="custom-tab-menu px-1 font-weight-500"
        @click="selectNavMenu(menu)"
      >
        <div class="d-flex">
          <feather-icon
            class="custom-margin-top-3"
            :icon="menu.icon"
            :class="{
              'mr-0 custom-margin-bottom-3': !menu.text,
            }"
          />
          <span v-if="menu.text" class="custom-padding-left-8">
            {{ menu.text }}
          </span>
        </div>
        <div
          class="custom-active-bar"
          :class="{ active: currentModule === menu.module }"
        ></div>
      </div>
    </div>

    <b-navbar-nav
      class="nav align-items-center ml-auto d-flex justify-content-center"
    >
      <!-- Manual -->
      <div v-if="userRole === 'Customer'">
        <b-nav-item-dropdown>
          <template #button-content>
            <feather-icon icon="BookIcon" size="21" />
          </template>

          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="onClickDownloadMainManual"
          >
            <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
            <span>Main Manual</span>
          </b-dropdown-item>

          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="onClickDownloadSiteAccessManualTh"
          >
            <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
            <span>Site Access Manual (TH)</span>
          </b-dropdown-item>

          <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="onClickDownloadSiteAccessManualEng"
          >
            <feather-icon size="16" icon="DownloadIcon" class="mr-50" />
            <span>Site Access Manual (ENG)</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </div>

      <!-- notification -->
      <notification-dropdown-custom />

      <!-- Setting -->
      <div
        v-if="isInternalAccess && hasSettingsPermission"
        class="navbar-module--setting-button-style d-flex flex-row-reverse"
        @click="goToSetting"
      >
        <feather-icon icon="SettingsIcon" width="22px" height="22px" />
      </div>

      <!-- Profile -->
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-flex align-items-between user-nav">
            <div
              class="user-name font-weight-bolder m-0"
              :class="{ 'custom-max-width': isInternalAccess }"
            >
              {{ userName }}
            </div>
            <span class="user-status">
              <span v-if="isInternalAccess">{{ userGroupPermissionName }}</span>
              <span v-else>{{ userRole }}{{ contractId }}</span>
            </span>
          </div>
          <!-- <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          /> -->
        </template>

        <b-dropdown-item
          v-if="isInternalAccess"
          link-class="d-flex align-items-center"
          @click="onClickEditProfile"
        >
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>Edit Profile</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="onClickChangePassword"
        >
          <feather-icon size="16" icon="KeyIcon" class="mr-50" />
          <span>Change Password</span>
        </b-dropdown-item>

        <template v-if="isShowApplicationLink">
          <b-dropdown-divider />

          <div class="header-app-text">Application</div>
    
          <b-dropdown-item
            v-if="oceanUrl"
            link-class="d-flex align-items-center"
            @click="handleOpenApp(oceanUrl)"
          >
            <!-- Ocean Icon (icon-tabler-ship) Start -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-ship mr-50"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
              />
              <path d="M4 18l-1 -5h18l-2 4" />
              <path d="M5 13v-6h8l4 6" />
              <path d="M7 7v-4h-1" />
            </svg>
            <!-- Ocean Icon (icon-tabler-ship) End -->
            <span>Ocean</span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="solarUrl"
            link-class="d-flex align-items-center"
            @click="handleOpenApp(solarUrl)"
          >
            <!-- Aurora Icon (icon-tabler-brand-google-analytics) Start -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-brand-google-analytics mr-50"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M10 9m0 1.105a1.105 1.105 0 0 1 1.105 -1.105h1.79a1.105 1.105 0 0 1 1.105 1.105v9.79a1.105 1.105 0 0 1 -1.105 1.105h-1.79a1.105 1.105 0 0 1 -1.105 -1.105z"
              />
              <path
                d="M17 3m0 1.105a1.105 1.105 0 0 1 1.105 -1.105h1.79a1.105 1.105 0 0 1 1.105 1.105v15.79a1.105 1.105 0 0 1 -1.105 1.105h-1.79a1.105 1.105 0 0 1 -1.105 -1.105z"
              />
              <path d="M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
            </svg>
            <!-- Aurora Icon (icon-tabler-brand-google-analytics) Start -->
            <span>Solar</span>
          </b-dropdown-item>
          
        </template>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <!-- ? Change Password Start -->
    <molecule-modal-dialog
      modalId="modal-change-password"
      buttonTextLeft="Save Changes"
      buttonColorLeft="primary"
      textTitle="Change Password"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="isErrorAtChangePasswordModal"
      @clickButtonLeft="onClickConfirmChangePasswordFromModal"
      @clickButtonRight="onClickCancelChangePasswordFromModal"
      @clickIconClose="onClickCancelChangePasswordFromModal"
    >
      <template #body>
        <div class="current-password-container w-80 mt-1">
          <atom-input
            v-model="changePasswordData.currentPassword"
            title="Current Password"
            placeholder="Current Password"
            type="password"
            :isAsterisk="true"
            :isError="isErrorAtCurrentPassword"
            :errorMessage="errorMessageAtCurrentPassword"
          ></atom-input>
        </div>
        <div class="new-password-container w-80 mt-1">
          <atom-input
            v-model="changePasswordData.newPassword"
            title="New Password"
            placeholder="New Password"
            type="password"
            :isAsterisk="true"
            :isError="
              isErrorAtNewPassword ||
              isNewPasswordNotTheSameAsConfirmNewPassword ||
              isErrorNotComplexPassword
            "
            :errorMessage="errorMessageAtNewPassword"
          ></atom-input>
        </div>
        <div class="confirm-new-password-container w-80 mt-1 mb-1">
          <atom-input
            v-model="changePasswordData.confirmNewPassword"
            title="Confirm New Password"
            placeholder="Confirm New Password"
            type="password"
            :isAsterisk="true"
            :isError="
              isErrorAtConfirmNewPassword ||
              isNewPasswordNotTheSameAsConfirmNewPassword ||
              isErrorNotComplexPassword
            "
            :errorMessage="errorMessageAtConfirmNewPassword"
          ></atom-input>
        </div>
        <b-alert
          :show="isErrorNotComplexPassword"
          variant="danger"
          class="w-80"
        >
          <div class="alert-body">
            <feather-icon icon="InfoIcon" class="mr-50" />
            <span>A password must</span>
            <ul>
              <li>have at least 8 characters.</li>
              <li>contain at least 1 uppercase letter.</li>
              <li>contain at least 1 lowercase letter.</li>
              <li>contain at least 1 digit.</li>
              <li>contain at least 1 special character.</li>
            </ul>
          </div>
        </b-alert>
      </template>
    </molecule-modal-dialog>
    <!-- ? Change Password End -->
  </div>
</template>

<script>
import {
  BAlert,
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BTabs,
  BTab,
} from "bootstrap-vue"
import { heightFade } from "@core/directives/animations"
import AtomInput from "@/components/atoms/AtomInput.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"

import store from "@/store/index"
import { mapGetters } from "vuex"

import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsUser from "@/mixins/mixinsUser"

import { externalChangePassword } from "@/api/api-module-iam"
import { changePassword } from "@/api/ims/api-profile-ims"
import NotificationDropdownCustom from "./NotificationDropdownCustom.vue"

import { PermissionUser } from "@/constants/permission-user"

import { SOLAR_URL, OCEAN_URL } from "@/constants"

export default {
  components: {
    AtomInput,
    BAlert,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BTabs,
    BTab,
    MoleculeModalDialog,
    NotificationDropdownCustom,
  },
  directives: {
    "height-fade": heightFade,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [mixins, mixinsValidator, mixinsUser],
  data() {
    return {
      solarUrl: SOLAR_URL,
      oceanUrl: OCEAN_URL,

      navbarUserName: "",
      currentModule: "",
      homeNavbar: {
        path: "/",
        module: "home",
        icon: "HomeIcon",
      },
      webPortalNavbar: {
        path: "",
        text: "Web Portal",
        module: "webPortal",
        icon: "GlobeIcon",
      },
      serverManagementNavbar: {
        path: "",
        text: "Server Manager",
        module: "serverManagement",
        icon: "HardDriveIcon",
      },
      backupManagementNavbar: {
        path: "",
        text: "Backup Manager",
        module: "backupManagement",
        icon: "HardDriveIcon",
      },
      networkConfigurationNavbar: {
        path: "",
        text: "Network Configuration",
        module: "networkConfiguration",
        icon: "HardDriveIcon",
      },
      internalHomeNavbar: {
        path: "/internal",
        module: "home",
        icon: "HomeIcon",
      },
      internalWebPortalNavbar: {
        path: "",
        text: "Web Portal",
        module: "webPortal",
        icon: "GlobeIcon",
      },
      internalServerManagementNavbar: {
        path: "",
        text: "Server Manager",
        module: "serverManagement",
        icon: "HardDriveIcon",
      },
      internalBackupManagementNavbar: {
        path: "",
        text: "Backup Manager",
        module: "backupManagement",
        icon: "HardDriveIcon",
      },
      internalNetworkConfigurationNavbar: {
        path: "",
        text: "Network Configuration",
        module: "networkConfiguration",
        icon: "HardDriveIcon",
      },
      internalGlobalSettingNavbar: {
        path: "/global-settings",
        text: "Settings",
        module: "globalSettings",
        icon: "SettingsIcon",
      },
      internalGlobalSettingDataManagementNavbar: {
        path: "/global-settings/data-management/service",
        text: "Data Management",
        module: "globalSettingsDataManagement",
        icon: "PlusSquareIcon",
      },

      /* Change Password Data Section Start*/
      changePasswordData: {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      },
      modalId: null,
      isValidateChangePasswordModalTrigger: false,
      /* Change Password Data Section End*/
    }
  },
  computed: {
    ...mapGetters("appPermission", ["getFullName", "getUserRole", "getIdcId"]),
    ...mapGetters("verticalMenu", [
      "getInternalFirstWpmPermission",
      "getInternalFirstSmsPermission",
      "getInternalFirstBmmPermission",
      "getInternalFirstNcmPermission",
      "getCustomerFirstWpmPermission",
    ]),
    ...mapGetters("authStore", [
      "getUserFullName",
      "getUserGroupPermissionName",
    ]),

    isShowApplicationLink() {
      return this.isInternalAccess && (this.solarUrl || this.oceanUrl)
    },

    hasSettingsPermission() {
      return this.hasPermission(PermissionUser.SETTINGS_READ)
    },

    isInternalAccess() {
      return this.$route.meta.type === "internal"
    },
    isReadyToRenderNavbar() {
      return this.$route.meta.type ? true : false
    },
    userName() {
      return this.isInternalAccess
        ? this.getUserFullName?.split(" ")[0] ?? this.navbarUserName
        : this.getFullName ?? this.navbarUserName
    },
    userGroupPermissionName() {
      return this.isInternalAccess
        ? this.getUserGroupPermissionName.replace(",", ", ")
        : ""
    },
    userRole() {
      return this.isInternalAccess ? "" : this.getUserRole
    },
    contractId() {
      return this.isInternalAccess
        ? ""
        : `: ${this.getIdcId.toString().padStart(8, "0")}`
    },
    internalFirstWpmPermission() {
      return this.getInternalFirstWpmPermission
    },
    internalFirstSmsPermission() {
      return this.getInternalFirstSmsPermission
    },
    internalFirstBmmPermission() {
      return this.getInternalFirstBmmPermission
    },
    internalFirstNcmPermission() {
      return this.getInternalFirstNcmPermission
    },
    customerFirstWpmPermission() {
      return this.getCustomerFirstWpmPermission
    },
    navbarMenu() {
      if (this.$route.path.includes("/global-settings")) {
        let internalNavbar = []
        internalNavbar.push(this.internalHomeNavbar)
        internalNavbar.push(this.internalGlobalSettingNavbar)
        internalNavbar.push(this.internalGlobalSettingDataManagementNavbar)
        return internalNavbar
      } else if (this.isInternalAccess) {
        let internalAccess = store.state.verticalMenu.internalEnabledNavbar
        let internalNavbar = []
        internalNavbar.push(this.internalHomeNavbar)
        if (internalAccess.webPortal) {
          internalNavbar.push(this.internalWebPortalNavbar)
        }
        if (internalAccess.serverManagement) {
          internalNavbar.push(this.internalServerManagementNavbar)
        }
        if (internalAccess.backupManagement) {
          internalNavbar.push(this.internalBackupManagementNavbar)
        }
        if (internalAccess.networkConfiguration) {
          internalNavbar.push(this.internalNetworkConfigurationNavbar)
        }
        return internalNavbar
      } else {
        let navbar = []
        navbar.push(this.homeNavbar)
        navbar.push(this.webPortalNavbar)
        return navbar
      }
    },

    /* Change Password Computed Section Start*/
    isErrorAtCurrentPassword() {
      return this.isValidateChangePasswordModalTrigger
        ? this.isEmptyString(this.changePasswordData.currentPassword)
        : false
    },
    errorMessageAtCurrentPassword() {
      return "Current Password is required"
    },
    isErrorAtNewPassword() {
      return this.isValidateChangePasswordModalTrigger
        ? this.isEmptyString(this.changePasswordData.newPassword)
        : false
    },
    errorMessageAtNewPassword() {
      if (this.isErrorNotComplexPassword) {
        return "The password does not match the policy"
      } else {
        return this.isEmptyString(this.changePasswordData.newPassword)
          ? "New Password is required"
          : "New Password not matching"
      }
    },
    isErrorAtConfirmNewPassword() {
      return this.isValidateChangePasswordModalTrigger
        ? this.isEmptyString(this.changePasswordData.confirmNewPassword)
        : false
    },
    errorMessageAtConfirmNewPassword() {
      if (this.isErrorNotComplexPassword) {
        return "The password does not match the policy"
      } else {
        return this.isEmptyString(this.changePasswordData.confirmNewPassword)
          ? "Confirm New Password is required"
          : "New Password not matching"
      }
    },
    isNewPasswordNotTheSameAsConfirmNewPassword() {
      return this.isValidateChangePasswordModalTrigger
        ? this.changePasswordData.newPassword !==
            this.changePasswordData.confirmNewPassword
        : false
    },
    isErrorNotComplexPassword() {
      return this.isValidateChangePasswordModalTrigger
        ? this.isNotComplexPassword(this.changePasswordData.newPassword)
        : false
    },
    isErrorAtChangePasswordModal() {
      return (
        this.isErrorAtCurrentPassword ||
        this.isErrorAtNewPassword ||
        this.isErrorAtConfirmNewPassword ||
        this.isNewPasswordNotTheSameAsConfirmNewPassword ||
        this.isErrorNotComplexPassword
      )
    },
    /* Change Password Computed Section End*/
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.currentModule = this.$route.meta.module
      },
    },
    userName() {
      if (this.userName) {
        this.navbarUserName = this.userName
      }
    },
  },
  methods: {
    selectNavMenu(menu) {
      let destinationPath = menu.path
      if (this.isEmptyString(menu.path)) {
        switch (menu.module) {
          case "webPortal":
            destinationPath = this.handleWpmModuleNavbarPath()
            break
          case "serverManagement":
            destinationPath = this.handleSmsModuleNavbarPath()
            break
          case "backupManagement":
            destinationPath = this.handleBmmModuleNavbarPath()
            break
          case "networkConfiguration":
            destinationPath = this.handleNcmModuleNavbarPath()
            break
          default:
            break
        }
      }
      if (this.$router.currentRoute.path !== destinationPath) {
        this.$router.push(destinationPath)
      }
    },
    handleWpmModuleNavbarPath() {
      if (this.isInternalAccess) {
        switch (this.internalFirstWpmPermission) {
          case PermissionUser.WPM.DASHBOARD_READ:
            return "/internal/web-portal/dashboard"

          case PermissionUser.WPM.EXCECUTIVE_DASHBOARD_READ:
            return "/internal/web-portal/executive-dashboard"

          case PermissionUser.WPM.TICKET_READ:
            return "/internal/web-portal/ticket"

          case PermissionUser.WPM.TICKET_ESCALATION_READ:
            return "/internal/web-portal/escalation/template"

          case PermissionUser.WPM.SITE_ACCESS_DASHBOARD_READ:
            return "/internal/web-portal/site-access/dashboard"

          case PermissionUser.WPM.SITE_ACCESS_READ:
            return "/internal/web-portal/site-access"

          // case PermissionUser.WPM.SMART_HAND_MANAGEMENT_READ:
          //   return "/internal/web-portal/smart-hand"

          // case PermissionUser.WPM.CROSS_CONNECT_READ:
          //   return "/internal/web-portal/cross-connect"

          // case PermissionUser.WPM.PARCEL_TRACKING_READ:
          //   return "/internal/web-portal/parcel-tracking"

          // case PermissionUser.WPM.INVENTORY_MANAGEMENT_READ:
          //   return "/internal/web-portal/inventory"

          case PermissionUser.WPM.NTDC_CONTRACT_READ:
            return "/internal/web-portal/idc"

          case PermissionUser.WPM.NTDC_CUSTOMER_READ:
            return "/internal/web-portal/idc/customer"

          case PermissionUser.WPM.NTDC_CONTACT_POINT_READ:
            return "/internal/web-portal/idc/contact"

          case PermissionUser.WPM.NTDC_ATTACHMENT_READ:
            return "/internal/web-portal/idc/attachment"

          case PermissionUser.WPM.IPAM_READ:
            return "/internal/web-portal/ipam"

          case PermissionUser.WPM.REPORT_TICKET_READ:
            return "/internal/web-portal/report"

          case PermissionUser.WPM.REPORT_SITE_ACCESS_READ:
            return "/internal/web-portal/report"

          case PermissionUser.WPM.REPORT_NTDC_CONTRACT_READ:
            return "/internal/web-portal/report"

          case PermissionUser.WPM.REPORT_IPAM_READ:
            return "/internal/web-portal/report"

          case PermissionUser.WPM.REPORT_WORKLOAD_READ:
            return "/internal/web-portal/report"

          default:
            return "/internal/home"
        }
      } else {
        switch (this.customerFirstWpmPermission) {
          case "login":
            return "/web-portal/customer-detail"

          case "wpmTicketTrackingAccess":
            return "/web-portal/ticket"

          case "wpmQrAccessAccess":
            return "/web-portal/site-access"

          case "wpmSmartHandManagementAccess":
            return "/web-portal/smart-hand"

          case "wpmCrossConnectAccess":
            return "/web-portal/cross-connect"

          case "wpmParcelTrackingAccess":
            return "/web-portal/parcel-tracking"

          default:
            return "/home"
        }
      }
    },
    handleSmsModuleNavbarPath() {
      switch (this.internalFirstSmsPermission) {
        case PermissionUser.SMS.DASHBOARD_READ:
          return "/server-management/dashboard"

        case PermissionUser.SMS.ALL_EVENTS_READ:
          return "/server-management/all-events"

        case PermissionUser.SMS.SERVER_MANAGEMENT_READ:
          return "/server-management/server-management"

        case PermissionUser.SMS.ALERT_READ:
          return "/server-management/alert"

        case PermissionUser.SMS.REPORT_READ:
          return "/server-management/report"

        case PermissionUser.SMS.DISCOVERY_READ:
          return "/server-management/discovery"

        case PermissionUser.SMS.POLICY_READ:
          return "/server-management/policy"

        default:
          return "/internal/home"
      }
    },
    handleBmmModuleNavbarPath() {
      switch (this.internalFirstBmmPermission) {
        case PermissionUser.BMM.DASHBOARD_READ:
          return "/backup-management/dashboard"

        case PermissionUser.BMM.MANAGED_SERVER_READ:
          return "/backup-management/server-management"

        case PermissionUser.BMM.REPOSITORY_READ:
          return "/backup-management/repository"

        case PermissionUser.BMM.BACKUP_AND_RESTORE_READ:
          return "/backup-management/backup"

        case PermissionUser.BMM.CREDENTIAL_READ:
          return "/backup-management/credential"

        case PermissionUser.BMM.VEEAM_READ:
          return "/backup-management/veeam"

        default:
          return "/internal/home"
      }
    },
    handleNcmModuleNavbarPath() {
      switch (this.internalFirstNcmPermission) {
        case PermissionUser.NCM.DASHBOARD_READ:
          return "/network-configuration/dashboard"

        case PermissionUser.NCM.NODE_MANAGEMENT_READ:
          return "/network-configuration/node-management"

        case PermissionUser.NCM.CONFIG_HISTORY_READ:
          return "/network-configuration/configuration-history"

        case PermissionUser.NCM.CONFIG_TEMPLATE_READ:
          return "/network-configuration/configuration-template"

        case PermissionUser.NCM.CONFIG_COMPARISON_READ:
          return "/network-configuration/configuration-comparison"

        case PermissionUser.NCM.DISCOVERY_READ:
          return "/network-configuration/discovery"

        case PermissionUser.NCM.CREDENTIAL_READ:
          return "/network-configuration/credential"

        case PermissionUser.NCM.BACKUP_SETTINGS_READ:
          return "/network-configuration/backup-settings"

        default:
          return "/internal/home"
      }
    },
    logout() {
      if (this.$route.meta.type === "internal") {
        // store.dispatch("appPermission/internalLogout")
        // store.dispatch("appAutoRefresh/setSMSDashboardAutoRefresh", true)
        // store.dispatch("appAutoRefresh/setBMMDashboardAutoRefresh", true)
        // store.dispatch("appAutoRefresh/setNCMDashboardAutoRefresh", true)
        // localStorage.removeItem("wpm-dashboard-auto-refresh")
        // localStorage.removeItem("wpm-executive-dashboard-auto-refresh")
        // localStorage.removeItem("sms-dashboard-auto-refresh")
        // localStorage.removeItem("bmm-dashboard-auto-refresh")
        // localStorage.removeItem("ncm-dashboard-auto-refresh")
        // this.$router.go("/internal/login")
        this.$store.dispatch("authStore/logoutOidc")
      } else {
        store.dispatch("appPermission/userLogout")
        this.$router.go("/login")
      }
    },
    goToSetting() {
      if (this.$route.path !== "/global-settings") {
        this.$router.push("/global-settings")
      }
    },
    goToHomePage() {
      if (this.$route.meta.type === "internal") {
        this.$router.push("/internal")
      } else {
        this.$router.push("/")
      }
    },
    /* Change Password Data Section Start*/
    async requestChangeInternalPasswordToApi(newPasswordData) {
      try {
        await changePassword(newPasswordData).then((response) => {
          if (response) {
            this.closeModal()
            this.toastSuccess("Changed Password Successfully")
          }
        })
      } catch (error) {
        this.toastError("Change Password Failed")
      }
    },
    async requestChangeExternalPasswordToApi(newPasswordData) {
      try {
        await externalChangePassword(newPasswordData).then((response) => {
          if (response) {
            this.toastSuccess("Changed Password Successfully")
            this.closeModal()
          }
        })
      } catch (error) {
        this.toastError("Change Password Failed")
      }
    },
    setChangePasswordDataToDefault() {
      this.changePasswordData = {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },
    onClickEditProfile() {
      this.$router.push("/internal/edit-profile")
    },
    onClickChangePassword() {
      this.modalId = "modal-change-password"
      this.$bvModal.show(this.modalId)
    },
    onClickConfirmChangePasswordFromModal() {
      this.isValidateChangePasswordModalTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorAtChangePasswordModal) {
          const newPasswordData = {
            currentPassword: this.changePasswordData.currentPassword,
            newPassword: this.changePasswordData.newPassword,
          }

          if (this.userRole?.toLowerCase() === "customer") {
            this.requestChangeExternalPasswordToApi(newPasswordData)
          } else {
            this.requestChangeInternalPasswordToApi(newPasswordData)
          }
          this.isValidateChangePasswordModalTrigger = false
          this.setChangePasswordDataToDefault()
        }
      })
    },
    onClickCancelChangePasswordFromModal() {
      this.closeModal()
      this.setChangePasswordDataToDefault()
      this.isValidateChangePasswordModalTrigger = false
    },
    /* Change Password Data Section End*/

    onClickDownloadMainManual() {
      window.open("/manuals/Customer_Manual.pdf", "_blank", "noreferrer")
    },

    onClickDownloadSiteAccessManualEng() {
      window.open("/manuals/Site_Access_Pocket_Guide_EN.pdf", "_blank", "noreferrer")
    },

    onClickDownloadSiteAccessManualTh() {
      window.open("/manuals/Site_Access_Pocket_Guide_TH.pdf", "_blank", "noreferrer")
    },

    handleOpenApp(path) {
      window.open(path, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
.header-app-text {
  padding: 0.65rem 1.28rem;
  font-size: 12px;
  color: #b9b9c3;
}

div.navbar-container.d-flex.align-items-center {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0;
  padding-bottom: 0;
}

.navbar-module--setting-button-style {
  height: 52px;
  padding: 1rem 1rem 0 1rem;
  border-radius: 0.4rem;
  &:hover {
    cursor: pointer;
  }
}

.home-page-menu {
  height: 52px;
  &:hover {
    cursor: pointer;
  }
}

.custom-margin-left {
  margin-left: 10px;
}

.nav-menu-alias--position {
  padding-bottom: 12px;
}

.text--bold {
  font-weight: 700;
}

.custom-max-width {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-status {
  padding-top: 4px;
}

.custom-tab-menu {
  display: flex;
  align-items: center;
  position: relative;
  height: 52px;
  transition: color 80ms linear;
  transition: font-weight 80ms linear;
  &:hover {
    cursor: pointer;
  }
}

.custom-active-bar {
  position: absolute;
  bottom: -10%;
  left: 0%;
  right: 0%;
  height: 0;
  width: 0;

  &.active {
    margin: auto;
    transition: width 100ms linear;
    transition: height 100ms linear;
    height: 5px;
    width: 100%;
    background: linear-gradient(30deg, #7367f0, rgba(115, 103, 240, 0.5));
  }
}

.alert-body ul {
  padding-left: 1.5rem !important;
  margin: 0;
}
</style>
